import React, { useEffect, useState } from 'react';
const trackFbEvent = (event: string, data?: Record<string, any>) => {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    ;
    (window as any).fbq('track', event, data);
  }
};
type Plan = 'megapack' | 'megapack-pro';
export function Pricing() {
  useEffect(() => {
    const section = document.getElementById('pricing');
    if (!section) return;
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        trackFbEvent('ViewContent', {
          content_name: 'Pricing Section',
          content_category: 'MegaPack Detailer Argentino'
        });
        observer.disconnect();
      }
    }, {
      threshold: 0.3
    });
    observer.observe(section);
    return () => observer.disconnect();
  }, []);
  const [selected, setSelected] = useState<Plan>('megapack-pro');
  const cartUrls: Record<Plan, string> = {
    megapack: 'https://checkout.construyeprogreso.com/cart/48195932749994:1',
    'megapack-pro': 'https://checkout.construyeprogreso.com/cart/48195645341866:1'
  };
  const ctaLabels: Record<Plan, string> = {
    megapack: '→ SÍ, QUIERO EL MEGAPACK DETAILER ARGENTINO',
    'megapack-pro': '→ SÍ, QUIERO EL MEGAPACK + EL MÉTODO CERÁMICO™'
  };
  return <section id="pricing" className="w-full px-4 py-10 text-base leading-6" style={{
    backgroundColor: '#0b0b0b',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-186">
      <div className="mx-auto max-w-3xl" data-id="element-187">
        {/* Heading */}
        <h2 className="font-black text-center text-white m-0 mb-2 text-[25px]" data-id="element-188">
          Elegí tu{' '}
          <span className="text-yellow-400" data-id="element-189">MegaPack Detailer Argentino:</span>
        </h2>
        <p className="text-center text-gray-400 m-0 mb-8 text-[12px]" data-id="element-190">
          Las dos opciones incluyen los 4 bonos exclusivos completos
        </p>

        {/* Plan Options */}
        <div className="mb-6 mx-auto max-w-2xl" data-id="element-191">
          {/* Option 1 — MegaPack Base */}
          <button onClick={() => setSelected('megapack')} className={`w-full text-left transition-all rounded-xl p-4 cursor-pointer shadow-sm ${selected === 'megapack' ? 'border-2 border-yellow-400' : 'border border-white/10'}`} style={{
          backgroundColor: 'rgba(255,255,255,0.03)'
        }} data-id="element-192">
            <div className="flex flex-row items-center gap-3" data-id="element-193">
              <div className="flex items-center gap-3 flex-1 min-w-0" data-id="element-194">
                {/* Radio */}
                <div className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 ${selected === 'megapack' ? 'border-yellow-400' : 'border-gray-600'}`} data-id="element-195">
                  {selected === 'megapack' && <div className="h-2.5 w-2.5 bg-yellow-400 rounded-full" data-id="element-196" />}
                </div>

                {/* Info */}
                <div className="min-w-0 flex-1" data-id="element-197">
                  <div className="flex flex-wrap items-center gap-2" data-id="element-198">
                    <span className="text-sm sm:text-base" data-id="element-199">🚗</span>
                    <span className="text-sm sm:text-base font-black text-white" data-id="element-200">
                      MEGAPACK DETAILER ARGENTINO
                    </span>
                  </div>
                  <p className="text-xs text-gray-400 mt-1 mb-0" data-id="element-201">
                    6 tomos + 4 bonos • De Principiante a Detailer Profesional
                  </p>
                </div>
              </div>

              {/* Price */}
              <div className="shrink-0 text-right" data-id="element-202">
                <div className="text-xs text-gray-500 line-through" data-id="element-203">
                  $49.990
                </div>
                <div className="text-xl sm:text-2xl font-black text-white" data-id="element-204">
                  $19.990
                </div>
              </div>
            </div>
          </button>

          {/* Option 2 — MegaPack PRO */}
          <button onClick={() => setSelected('megapack-pro')} className={`w-full text-left transition-all rounded-xl p-4 mt-3 cursor-pointer shadow-sm ${selected === 'megapack-pro' ? 'border-2 border-yellow-400' : 'border border-white/10'}`} style={{
          backgroundColor: 'rgba(234, 179, 8, 0.05)',
          boxShadow: selected === 'megapack-pro' ? 'rgba(234, 179, 8, 0.15) 0px 0px 30px 0px' : 'none'
        }} data-id="element-205">
            <div className="flex gap-3 flex-row items-center justify-end" data-id="element-206">
              <div className="flex items-start gap-3 flex-1 min-w-0" data-id="element-207">
                {/* Radio */}
                <div className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 mt-0.5 ${selected === 'megapack-pro' ? 'border-yellow-400' : 'border-gray-600'}`} data-id="element-208">
                  {selected === 'megapack-pro' && <div className="h-2.5 w-2.5 bg-yellow-400 rounded-full" data-id="element-209" />}
                </div>

                {/* Info */}
                <div className="min-w-0 flex-1" data-id="element-210">
                  <div className="flex flex-wrap items-center gap-2" data-id="element-211">
                    <span className="text-sm sm:text-base" data-id="element-212">🏆</span>
                    <span className="text-sm sm:text-base font-black text-white" data-id="element-213">
                      MEGAPACK + EL MÉTODO CERÁMICO™
                    </span>
                  </div>
                  <div className="mt-1.5 flex flex-wrap items-center gap-1.5" data-id="element-214">
                    <span className="bg-yellow-400 text-[10px] font-black text-gray-900 rounded-full px-2 py-0.5" data-id="element-215">
                      ⭐ MÁS ELEGIDO
                    </span>
                    <span className="bg-yellow-400/10 text-[10px] font-bold text-yellow-400 border border-yellow-400/30 rounded-full px-2 py-0.5" data-id="element-216">
                      AHORRÁS $20.000
                    </span>
                  </div>
                  <p className="text-xs text-gray-400 mt-1.5 mb-0" data-id="element-217">
                    6 tomos + 4 bonos + El Método Cerámico™ (clientes de lujo,
                    sellado cerámico avanzado, cómo cobrar +$400.000 por
                    servicio y dominar el Vidrio Líquido).
                  </p>
                </div>
              </div>

              {/* Price */}
              <div className="shrink-0 text-right" data-id="element-218">
                <div className="text-xs text-gray-500 line-through" data-id="element-219">
                  $69.990
                </div>
                <div className="text-xl sm:text-2xl font-black text-yellow-400" data-id="element-220">
                  $27.990
                </div>
              </div>
            </div>
          </button>
        </div>

        {/* CTA Button */}
        <div className="mx-auto max-w-2xl" data-id="element-221">
          <a href={cartUrls[selected]} onClick={() => trackFbEvent('InitiateCheckout', {
          content_name: selected === 'megapack-pro' ? 'MegaPack + El Método Cerámico™' : 'MegaPack Detailer Argentino',
          content_category: 'Detailer Argentino',
          value: selected === 'megapack-pro' ? 27990 : 19990,
          currency: 'ARS'
        })} className="block w-full bg-yellow-400 text-gray-900 text-center text-sm sm:text-base font-black rounded-xl py-4 no-underline transition-colors animate-pulse-green will-change-transform" data-id="element-222">
            {ctaLabels[selected]}
          </a>

          <p className="text-center text-xs italic text-gray-400 mt-3 mb-0" data-id="element-223">
            La más elegida por detailers que quieren cobrar alto ticket y llenar
            su agenda en menos de 30 días
          </p>

          {/* Trust Badges */}
          <div className="mt-6 flex flex-wrap items-center justify-center gap-3 text-xs text-gray-400 rounded-lg px-4 py-3 shadow-sm" style={{
          backgroundColor: 'rgba(255,255,255,0.03)',
          border: '1px solid rgba(234, 179, 8, 0.2)'
        }} data-id="element-224">
            <span data-id="element-225">🔒 Pago seguro</span>
            <span data-id="element-226">⚡ Acceso en 5 min</span>
            <span data-id="element-227">🛡️ Garantía 30 días</span>
            <span data-id="element-228">💳 Mercado Pago</span>
          </div>
        </div>
      </div>
    </section>;
}